<div class="row">
  <div class="col-md-12">
    <form [formGroup]="GForm" (ngSubmit)="CreateData()" *ngIf="IsActive">
      <div class="cardTabs">
        <div class="formCard">
          <div class="row">
            <div class="col-md-12">
              <app-transaction-header [THForm]="GForm" (TransactionHeaderData)="getTransactionHeaderData($event)">
              </app-transaction-header>
            </div>
          </div>
        </div>
        <div class="formCard mt-3">
          <div class="row" formGroupName="Transaction" [hidden]="PaymentMainPage == false">
            <div class="form-group col-md-6">
              <label>{{ 'Client' | translate }}</label>
              <!-- <ng-select placeholder="{{ 'SearchClients' | translate }}" [multiple]="false" [items]="Clients" required
                bindLabel="Name" bindValue="Id" name="ClientId" formControlName="ClientId" (search)="onSearch($event)"
                (change)="GetBooking($event)">
              </ng-select> -->

              <ng-select [placeholder]="'SearchClients' | translate" formControlName="ClientId" name="ClientId"
                [multiple]="false" [items]="Clients" bindLabel="Name" bindValue="Id" [searchFn]="customSearchFn1"
                (change)="GetBooking($event)" (clear)="clearClientId()" (search)="onSearch($event)" required>
                <ng-template ng-option-tmp let-item="item">
                  <div class="list-client-insearch">
                    <div [ngClass]="{'first-char': !item.IsBanned, 'first-char-banned' : item.IsBanned }"
                      [title]="item.IsBanned ? (('BannedClient' | translate) + ' - ' + ('BanReason' | translate) + ':' + item.BanReason) : item.Name">
                      {{ item.Name | slice : 0 : 1 }}
                    </div>
                    <div [ngClass]="{'info-client': !item.IsBanned, 'info-client-banned' : item.IsBanned }"
                      [title]="item.IsBanned ? (('BannedClient' | translate) + ' - ' + ('BanReason' | translate) + ':' + item.BanReason) : item.Name">
                      {{ item.Name }} <br />
                      <span>{{ item.Mobile }}</span>
                    </div>
                  </div>
                </ng-template>
              </ng-select>
            </div>
            <div class="col-md-6">
              <div class="form-group ">
                <label>{{ 'Booking' | translate }}</label>
                <ng-select placeholder="{{ 'Booking' | translate }}" [multiple]="false" [items]="Bookings" required
                  bindLabel="BookingName" bindValue="Id" name="BookingId" formControlName="BookingId"
                  (change)="PushBookingDP($event)">
                </ng-select>
              </div>
            </div>
          </div>

          <div *ngIf="!PaymentMainPage" class="row">
            <div class="col-md-12">
              <table class="table">
                <tr>

                  <td> {{ 'BookingNumber' | translate }} </td>
                  <td> {{booking?.Id}} </td>
                  <td> {{ 'ClientName' | translate }} </td>
                  <td> {{booking?.ClientName}} </td>
                  <td> {{ 'ClientMobile' | translate }} </td>
                  <td> {{booking?.ClientMobile}} </td>

                </tr>
              </table>
            </div>
          </div>
          <hr>

          <div class="row" *ngIf="booking">
            <div class="col-md-12">
              <table class="table table-sm table-bordered">
                <tr class="MainColor white-text">

                  <th>{{'BookingTotal' | translate}} </th>
                  <th>{{'BookingPaidValue' | translate}} </th>
                  <th>{{'DownPaymentRemainingOrBookingRemaining' | translate}}</th>
                  
                </tr>
                <tr>
                  <td>{{booking.TotalNetPrice.toFixed(sharedService.GetFractionRoundCount)}} </td>
                  <td>{{booking.PaidAmount}}</td>
                  <td>
                    <input type="number" (keypress)="sharedService.allowNumbersOnly($event)" class="form-control"
                      [(ngModel)]="downPaymentRemainingOrBookingRemaining" name="downPaymentRemainingOrBookingRemaining"
                      [ngModelOptions]="{standalone: true}" (keyup)="SetdownPayment($event)" min="0.1" required>
                    <!--  -->
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <hr>
          <div class="row" *ngIf="sharedService?.CurrentBranch?.AllowUseSalesTaxRate &&
           sharedService?.CurrentBranch?.SalesTaxRate > 0 && getTotal() > 0">
            <div class="col-md-12">
              <h6 class="text-center text-info"> {{'TheTaxValue' | translate}}: &nbsp; {{
                getTaxValue().toFixed(sharedService.GetFractionRoundCount) + " " + CurrencyName}}
                &nbsp;&nbsp;&nbsp; {{'Total' | translate}}: &nbsp; {{
                getTotal().toFixed(sharedService.GetFractionRoundCount) + " " + CurrencyName}}</h6>
            </div>
            <hr>
          </div>
          <div class="row">
            <div class="col-md-12">
              <app-transaction-payment [TPForm]="GForm"></app-transaction-payment>
              <div class= "ltr:text-end rtl:text-end  ">
                <button type="button" class="btn btn-sm btn-primary" (click)="PushTransactionsPayments()">
                  {{'AddOtherPayment' | translate}} </button>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-12">
              <hr>
            </div>
            <div class="col-md-4"></div>
            <div class="col-md-4">
              <div class= "ltr:text-end rtl:text-end  ">
                <button class="btn btn-submit" type="submit" [disabled]="btnLoading || !GForm.valid || !downPaymentRemainingOrBookingRemaining ||
                  downPaymentRemainingOrBookingRemaining <= 0">
                  <span *ngIf="!btnLoading"> {{ 'Submit' | translate }}</span>
                  <span *ngIf="btnLoading"> <i class="fas fa-circle-notch fa-spin"></i> {{ 'Loading' | translate
                    }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
    <div class="col-md-12" *ngIf="!IsActive">
      <div class="IsWarning">
        <i class="fas fa-exclamation-triangle"></i>
        <br>
        <br>
        <br>
        <h5>{{MessageValidation}}</h5>
      </div>
    </div>
  </div>
</div>
